<template>
    <div 
        class="modal fade"
        id="addEsercizioModal"
        tabindex="-1"
        aria-labelledby="addContact"
        aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="addContact">
                        {{isEdit ? 'Modifica' : 'Aggiungi'}} Esercizio
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <form @submit.prevent="submit">
                <div class="modal-body">
                    <div class="col-md-12 text-start">
                        <label for="nome" class="form-label">Nome:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.nome ? true : false}" id="nome" v-model="form.nome" autofocus aria-describedby="nomeFeedback" required>
                            <div v-if="errors.nome" id="nomeFeedback" class="invalid-feedback">
                                {{errors.nome}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-start">
                        <label for="descrizione" class="form-label">Descrizione:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.descrizione ? true : false}" id="descrizione" v-model="form.descrizione" autofocus aria-describedby="descrizioneFeedback" required>
                            <div v-if="errors.descrizione" id="descrizioneFeedback" class="invalid-feedback">
                                {{errors.descrizione}}
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 text-start">
                        <label for="obiettivo" class="form-label">Obiettivo:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.obiettivo ? true : false}" id="obiettivo" v-model="form.obiettivo" autofocus aria-describedby="obiettivoFeedback">
                            <div v-if="errors.obiettivo" id="obiettivoFeedback" class="invalid-feedback">
                                {{errors.obiettivo}}
                            </div>
                        </div>
                    </div> 

                    <div class="col-md-12 text-start">
                        <label for="minuti" class="form-label">Minuti Esecuzione:</label>
                        <div class="input-group has-validation">
                            <input type="number" :class="{'form-control':true, 'is-invalid':errors.minuti ? true : false}" id="minuti" v-model="form.minuti" autofocus aria-describedby="minutiFeedback">
                            <div v-if="errors.minuti" id="minutiFeedback" class="invalid-feedback">
                                {{errors.minuti}}
                            </div>
                        </div>
                    </div> 
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                    >
                        Annulla
                    </button>
                    <button type="submit" class="btn btn-primary" :disabled="form.processing">
                        {{isEdit ? 'Aggiorna' : 'Salva'}}
                    </button>
                </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from 'bootstrap';

export default {
    props: {
        esercizio: Object,
        isEdit: Boolean
    },
    data() {
        return {
            modal: null,
            form: this.$inertia.form({
                nome: this.esercizio ? this.esercizio.nome : "" ,
                descrizione: this.esercizio ? this.esercizio.descrizione : "" ,
                obiettivo: this.esercizio ? this.esercizio.obiettivo : "",
                minuti: this.esercizio ? this.esercizio.minuti : "",
            }),
            errors: {
               nome: null,
               descrizione: null,
               obiettivo: null,
               minuti: null
            },
        };
    },
    mounted() {
        var modalEl = document.getElementById('addEsercizioModal')
        this.modal = new Modal(modalEl)
        this.modal.show();
        
        modalEl.addEventListener('hidden.bs.modal',  (event) => {
            this.$emit('modelStatusChanged',false)
        })
    },
    methods: {
        close(){
            //this.isOpen = false
        },
        submit() {
            let route = this.isEdit ? this.route("esercizi.update",this.esercizio.id) : this.route("esercizi.store")
            let method = this.isEdit ? 'patch' : 'post'
            this.form[this.isEdit ?'patch' : 'post'](route, {
                onError: (errors) => {
                    
                    if (Object.entries(errors).length !== 0) {
                        var toast = {
                            bg: "bg-danger",
                        };

                        
                        if (errors.hasOwnProperty("nome")) {
                            toast.message = errors.nome;
                            this.errors.nome = errors.nome;
                        }

                        if (errors.hasOwnProperty("descrizione")) {
                            toast.message = errors.descrizione;
                            this.errors.descrizione = errors.descrizione;
                        }
                    }
                }, 
                onSuccess: () => {
                    this.form.reset();
                    this.modal.hide();

                }
            });
        },
    },
};
</script>
